import { useLocation } from "react-router-dom";
import { Breadcrumb, Crumb } from "../../components/ui";
import { NAV_MODEL } from "../navModel";

/**
 * Breadcrumb de las pantallas que SÍ están en el menú, derivado del navModel.
 *
 * Son 39 destinos: hardcodear uno por pantalla sería repetir en 39 archivos una
 * jerarquía que el navModel ya describe, y quedaría desincronizada la primera
 * vez que alguien mueva un ítem de grupo.
 *
 * Las pantallas que NO están en el menú (detalle, editar) siguen poniendo su
 * propio <Breadcrumb>, porque llevan el nombre de la entidad — algo que no se
 * puede derivar de la navegación. Los dos conjuntos son disjuntos por
 * definición, así que no hay riesgo de que aparezcan dos.
 *
 * Va montado en PageLayout, entre el header y el contenido: BO-NAV-03 pide
 * explícitamente que no quede anidado dentro de una card.
 */
export const AutoBreadcrumb = () => {
  const { pathname } = useLocation();

  const items: Crumb[] = [];

  for (const grupo of NAV_MODEL) {
    if (grupo.to === pathname) {
      // Enlace directo: un solo tramo no aporta jerarquía, no se muestra.
      return null;
    }
    const item = grupo.items?.find((i) => i.to === pathname);
    if (item) {
      // El grupo es un acordeón, no una ruta: va como texto, no como link.
      items.push({ label: grupo.label }, { label: item.label });
      break;
    }
  }

  if (items.length === 0) return null;

  return <Breadcrumb items={items} />;
};
